<template>
  <transition name="formSearch" @afterEnter="afterEnter">
    <div class="formSearch" v-if="isOpen" :class="{ headerFixed: isHeaderFix }">
      <div
        v-if="isSearch === false"
        class="formSearchDimmed"
        @click="closeSearchForm"
      ></div>
      <form
        action="."
        class="formSearchContents"
        :class="{ typing: keyword }"
        @submit.prevent
      >
        <input
          type="search"
          v-model="keyword"
          placeholder="상품검색"
          @keyup.enter="doSearch"
          ref="input-search"
          autocomplete="off"
        />
        <button type="button" class="btDel" @click="doDel($event)"></button>
        <button type="button" class="btSearch" @click="doSearch">
          <span class="icon iconSearch"></span>
          <span class="accessibilityHide">검색</span>
        </button>
        <button
          type="button"
          class="btCancel"
          @click="closeSearchForm"
          v-if="!isHeaderFix"
        >
          취소
        </button>
      </form>
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FormSearch',
  components: {},
  data: function() {
    return {
      keyword: this.$route.params.query || ''
    }
  },
  watch: {
    isOpen: {
      handler(n, o) {
        if (!this.keyword) {
          this.keyword = this.$route.params.query
        } else if (n === false) {
          this.keyword = ''
        }
      }
    },
    '$route.path': {
      //
      handler(n, o) {
        if (/search/g.test(n) === false) {
          this.closeSearchForm()
        }
      }
    }
  },
  computed: {
    ...mapGetters('search', ['isOpen', 'isHeaderFix']),
    isSearch() {
      return /search/g.test(this.$route.name)
    },
    isTagTab() {
      return this.$route.name === 'search-tag'
    }
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('search', ['closeSearchForm']),
    doSearch() {
      if (this.keyword) {
        const url = `/search/${this.isTagTab ? 'tag' : 'product'}/${
          this.keyword
        }`

        if (this.isSearch) {
          this.$router.replace(url)
        } else {
          this.$router.push(url)
        }

        this.$refs['input-search'].blur()
      } else {
        this.openModal({ type: 'alert', message: '검색어를 입력해 주세요.' })
      }
    },
    afterEnter() {
      if (this.$route.name.indexOf('search-') < 0) {
        // ios는 정책상 autofocus를 지원하지 않는 듯
        this.$refs['input-search'].focus()
      }
    },
    doDel(e) {
      e.preventDefault()
      this.keyword = ''
      this.$refs['input-search'].focus()
    }
  },
  mounted() {
    if (/search/g.test(this.$route.name) === false) {
      this.closeSearchForm()
    }
  }
}
</script>

<style lang="scss">
.formSearch {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9998;
}
.formSearchDimmed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.formSearchContents {
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  height: 56px;
  padding: 9px 0 0;
  // padding-right: 61px; safeArea
  // padding-left: 16px; safeArea
  margin-left: -50%;
  background-color: #fff;
  text-align: right;
  input {
    width: 100%;
    height: 40px;
    font-size: 16px;
    padding: 2px 72px 0 10px;
    border: 2px solid #31333c;
    &:focus {
      border-color: #6134f1;
      outline: 0;
    }
    &:focus + button .iconSearch {
      background-position: -50px 0;
    }
    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }
    &::-ms-clear,
    &::-ms-reveal {
      display: none;
      width: 0;
      height: 0;
    }
  }
  .btSearch {
    position: absolute;
    top: 9px;
    right: 61px;
    width: 39px;
    height: 40px;
  }
  .btDel {
    display: none;
    position: absolute;
    right: 102px;
    top: 19px;
    height: 20px;
    width: 27px;
    border-right: 1px solid #a4a6b5;
    background: url('../../assets/images/set_icon.png') no-repeat -50px -349px;
    background-size: 100px;
  }
  .btCancel {
    position: absolute;
    top: 9px;
    right: 0;
    width: 61px;
    height: 40px;
  }
}
.typing {
  .btDel {
    display: block;
  }
}
.headerFixed {
  left: 50%;
  max-width: 1024px;
  height: 60px;
  transform: translate(-50%, 54px);
  .formSearchDimmed {
    opacity: 0;
  }
  .formSearchContents {
    padding: 9px 16px 0;
  }
  .btDel {
    transform: translateX(45px);
  }
  .btSearch {
    transform: translateX(45px);
  }
}
.formSearch-enter,
.formSearch-leave-to {
  .formSearchDimmed {
    opacity: 0;
  }
  .formSearchContents {
    opacity: 0;
    input {
      transform: translateX(55px);
      width: 39px;
    }
    .btSearch {
      transform: translateX(55px);
    }
  }
}
.formSearch-enter-active {
  transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  .formSearchContents,
  .formSearchDimmed,
  input,
  .btSearch {
    transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }
}
.formSearch-leave-active {
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  .formSearchContents,
  .formSearchDimmed,
  input,
  .btSearch {
    transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
  }
}
.headerFixed.formSearch-enter-active,
.headerFixed.formSearch-leave-active {
  transition: all 0s cubic-bezier(0.19, 1, 0.22, 1);
  .formSearchContents,
  .formSearchDimmed,
  input,
  .btSearch {
    transition: all 0s cubic-bezier(0.19, 1, 0.22, 1);
  }
}
</style>
